import { IconBed, IconBuildingBridge, IconCar, IconInfoCircle, IconPlane, IconSailboat, IconTrain, IconWalk } from "@tabler/icons-react";
import type { ReactNode } from "react";

/** The icon of a service or timeline kind, shared by the trip, proposal and payment screens. */
export function kindIcon(kind: string, size = 20): ReactNode {
  switch (kind) {
    case "flight":
      return <IconPlane size={size} stroke={1.5} />;
    case "accommodation":
    case "hotel":
      return <IconBed size={size} stroke={1.5} />;
    case "transfer":
    case "car":
      return <IconCar size={size} stroke={1.5} />;
    case "activity":
    case "experience":
      return <IconWalk size={size} stroke={1.5} />;
    case "rail":
      return <IconTrain size={size} stroke={1.5} />;
    case "cruise":
      return <IconSailboat size={size} stroke={1.5} />;
    case "note":
      return <IconInfoCircle size={size} stroke={1.5} />;
    default:
      return <IconBuildingBridge size={size} stroke={1.5} />;
  }
}
